import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { LoadingService } from '../../services/loading.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'loader',
  template: `
    @if (loading$ | async) {
      <div class="loading-overlay">
        <div class="spinner"></div>
      </div>
    }
    `,
  styleUrls: ['./loader.component.scss'],
  imports: [CommonModule]
})
export class LoaderComponent implements OnInit {
  loading$!: Observable<boolean>;

  constructor(private loadingService: LoadingService) {}

  ngOnInit(): void {
    this.loading$ = this.loadingService.loading$;
  }
}